/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SubscriptionsSubscriptionVariables = {};
export type SubscriptionsSubscriptionResponse = {
    readonly broadcastNotification: {
        readonly id: string;
        readonly " $fragmentRefs": FragmentRefs<"BroadcastNotificationDropdown_notification">;
    };
};
export type SubscriptionsSubscription = {
    readonly response: SubscriptionsSubscriptionResponse;
    readonly variables: SubscriptionsSubscriptionVariables;
};



/*
subscription SubscriptionsSubscription {
  broadcastNotification {
    id
    ...BroadcastNotificationDropdown_notification
  }
}

fragment BroadcastNotificationDropdown_notification on BroadcastNotification {
  broadcast {
    title
    message
    deliveryDateTime
    id
  }
  id
  read {
    createdAt
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionsSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BroadcastNotification",
        "kind": "LinkedField",
        "name": "broadcastNotification",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BroadcastNotificationDropdown_notification"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscriptionsSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BroadcastNotification",
        "kind": "LinkedField",
        "name": "broadcastNotification",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Broadcast",
            "kind": "LinkedField",
            "name": "broadcast",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deliveryDateTime",
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BroadcastNotificationRead",
            "kind": "LinkedField",
            "name": "read",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2eb089156714ebd1c2f1c23c37b4e3aa",
    "id": null,
    "metadata": {},
    "name": "SubscriptionsSubscription",
    "operationKind": "subscription",
    "text": "subscription SubscriptionsSubscription {\n  broadcastNotification {\n    id\n    ...BroadcastNotificationDropdown_notification\n  }\n}\n\nfragment BroadcastNotificationDropdown_notification on BroadcastNotification {\n  broadcast {\n    title\n    message\n    deliveryDateTime\n    id\n  }\n  id\n  read {\n    createdAt\n  }\n}\n"
  }
};
})();
(node as any).hash = '1e618b1097375a5bb390be19bad946fa';
export default node;
